"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var retry_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/retry-icon.svg"));
var react_redux_1 = require("react-redux");
var PrefixableTextField_1 = __importDefault(require("../../../user/widgets/PrefixableTextField"));
var TrailingButton_1 = __importDefault(require("../../../user/components/Drawer/ControlPanel/widgets/TrailingButton"));
var ConfigOption_1 = __importStar(require("../../../user/widgets/ConfigOption"));
var actions_1 = __importDefault(require("../../actions"));
var Tooltip_1 = __importDefault(require("../../../user/widgets/Tooltip"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        root: (_a = {
                display: 'flex',
                flexDirection: 'column',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: theme.spacing(3),
                backgroundColor: 'white',
                padding: theme.spacing(6),
                height: '100%'
            },
            _a[theme.breakpoints.up('md')] = {
                marginTop: theme.spacing(4),
            },
            _a[theme.breakpoints.down('sm')] = {
                marginBottom: theme.spacing(6),
                paddingBottom: theme.spacing(1),
                height: 'auto',
            },
            _a),
        configOptionWrapper: {
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '775px',
            justifyContent: 'flex-start',
            marginTop: theme.spacing(3),
        },
        apiKeyInfoText: {
            textAlign: 'left',
            marginBottom: theme.spacing(3),
        },
        createApiKeyButton: {
            marginTop: '41px',
            width: '168px',
            minWidth: '90px',
            color: 'white',
            background: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            },
        },
        retryIcon: {
            width: '17px',
        },
        link: {
            color: '#FFC700',
            fontWeight: 700,
        },
    });
});
/**
 * @component Default display component in place of generated api key.
 */
var ApiKeyGraphic = function () {
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var dispatch = react_redux_1.useDispatch();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.apiKeyInfoText }, t('apiIntegration.message.afterGenerating')),
        react_1.default.createElement(core_1.Divider, null),
        react_1.default.createElement("div", { className: classes.configOptionWrapper },
            react_1.default.createElement(ConfigOption_1.default, { title: react_1.default.createElement(react_1.default.Fragment, null,
                    t('apiIntegration.message.labelAPIkey'),
                    ' ',
                    react_1.default.createElement(Tooltip_1.default, { title: t('apiIntegration.message.tooltipAPIKey'), imageAltText: "API Key help" })), leading: react_1.default.createElement(PrefixableTextField_1.default, { value: "******************", onChange: function () { }, placeholder: "", helperText: ' ', disabled: true }), trailing: react_1.default.createElement(TrailingButton_1.default, { onClick: function () {
                        dispatch(actions_1.default.generateApiKey());
                    }, variant: "contained", fullWidth: isMobileView },
                    t('button.regenerateAPIKey'),
                    " \u00A0",
                    react_1.default.createElement("img", { className: classes.retryIcon, src: retry_icon_svg_1.default, alt: "Regenerate" })), wrapTrailing: isMobileView, trailingPosition: ConfigOption_1.TrailingPosition.end }))));
};
exports.default = ApiKeyGraphic;
